import React, { useEffect, useState } from "react";
import Header from "./Header";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { Card } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Link } from "react-router-dom";

function ProductDetailExtra() {
  let server_url = localStorage.getItem("server_url");
  const [productDetails, setProductDetails] = useState([]);
  let { product_id } = useParams();
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    getProductDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getProductDetails = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("product_id", product_id);
      const res = await axios.post(
        `${server_url}product_details.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res.data.status === "1") {
        setProductDetails(res.data.result);
      } else {
        setProductDetails([]);
        // toast.warning(res.data.error);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  };

  return (
    <div className="page-content header-clear-medium">
      <Header />

      <div className="container mt-3">
        {productDetails.length === 0 ? (
          <div className="text-center mt-5">
            <h5 className="text-muted">Product Details Not Available</h5>
          </div>
        ) : (
          productDetails.map((product, index) => (
            <div className="card card-style mb-3" key={index}>
              <div className="content text-center">
                {/* UPI QR Image */}
                {product.product_preview && (
                  <div
                    className="container justify-content-center"
                    style={{
                      marginBottom: "15px",
                      height: "360px",
                    }}
                  >
                    <Swiper
                      centeredSlides={false}
                      autoplay={{ delay: 3000, disableOnInteraction: false }}
                      modules={[Autoplay, Pagination, Navigation]}
                      className="mySwiper"
                      loop={true}
                      slidesPerView={1}
                      spaceBetween={30}
                      pagination={{ clickable: true }}
                    >
                      {product.product_preview.map((imageUrl, index) => (
                        <SwiperSlide key={index}>
                          <Card className="p-0 overflow-hidden">
                            {/* shadow */}
                            <div className="overflow-hidden rounded p-0 bg-light mobbannerall">
                              <Card.Img
                                style={{ height: "360px", objectFit: "cover" }}
                                className="mobbanner"
                                variant="top"
                                src={imageUrl}
                                onClick={() => setSelectedImage(imageUrl)}
                              />
                            </div>
                          </Card>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                )}

                {/* Bank Details */}
                <div className="text-start">
                  <span className="text-muted font-11">Name:</span>
                  <h6 className="fw-bold mb-0">{product.product_name}</h6>

                  <span className="text-muted font-11">Series:</span>
                  <h6 className="fw-bold mb-0">{product.series_name}</h6>

                  <span className="text-muted font-11">Size:</span>
                  <h6 className="fw-bold mb-0">{product.size_name}</h6>

                  <span className="text-muted font-11">Grade:</span>
                  <h6 className="fw-bold mb-0">{product.product_grade}</h6>

                  <span className="text-muted font-11">Loading Plant:</span>
                  <h6 className="fw-bold mb-0">{product.loading_plant_name}</h6>

                  <span className="text-muted font-11">Repeat Order Time:</span>
                  <h6 className="fw-bold mb-0">
                    {product.product_repeat_order_time_in_days} Days
                  </h6>

                  <span className="text-muted font-11">Per Box:</span>
                  <h6 className="fw-bold mb-0">
                    {product.product_piece_per_box}
                  </h6>

                  <span className="text-muted font-11">Weight / Box:</span>
                  <h6 className="fw-bold mb-0">
                    {product.product_weight_per_box}
                  </h6>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Modal for Zoomed Image */}
      {selectedImage && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.95)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{ background: "transparent", border: "none" }}
            >
              <div className="modal-body text-center">
                <TransformWrapper>
                  <TransformComponent>
                    <img
                      src={selectedImage}
                      className="img-fluid"
                      style={{
                        objectFit: "contain",
                        marginLeft: "auto",
                        marginRight: "auto",
                        maxWidth: "100%",
                        cursor: "grab",
                      }}
                      alt="Zoomed"
                    />
                  </TransformComponent>
                </TransformWrapper>

                <button
                  className="btn btn-danger mt-3"
                  onClick={() => setSelectedImage(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <center>
        <Link
          style={{ width: "90%" }}
          to={"/Inquiry/"+product_id}
          className="btn btn-3d btn-m btn-full mb-3 rounded-xl text-uppercase font-900 shadow-s border-red-dark bg-red-light"
        >
          Inquiry
        </Link>
      </center>
    </div>
  );
}

export default ProductDetailExtra;
